import { Component, Inject, OnDestroy, OnInit } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';

import { SnackbarService } from 'src/app/shared/services/snackbar.service';
import { ICvMetadata } from 'src/app/shared/models/collaborateur';
import { CollaborateurService } from '../collaborateur.service';

export interface ICvViewerDialogData {
  collaborateurId: string;
  nom: string;
  prenom: string;
}

@Component({
  selector: 'app-cv-viewer-dialog',
  templateUrl: './cv-viewer-dialog.component.html',
  styleUrls: ['./cv-viewer-dialog.component.less']
})
export class CvViewerDialogComponent implements OnInit, OnDestroy {

  loading = true;
  loadError = false;

  metadata: ICvMetadata | null = null;
  pdfSafeUrl: SafeResourceUrl | null = null;

  private objectUrl: string | null = null;

  constructor(
    private collaborateurService: CollaborateurService,
    private sanitizer: DomSanitizer,
    private snackbarService: SnackbarService,
    public dialogRef: MatDialogRef<CvViewerDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: ICvViewerDialogData
  ) {}

  ngOnInit(): void {
    this.loadMetadata();
    this.loadPdf();
  }

  ngOnDestroy(): void {
    // Libère la mémoire allouée par le navigateur pour le blob affiché
    if (this.objectUrl) {
      URL.revokeObjectURL(this.objectUrl);
    }
  }

  private loadMetadata(): void {
    this.collaborateurService.getCvMetadata(this.data.collaborateurId).subscribe({
      next: (metadata) => this.metadata = metadata,
      error: () => {
        // Non bloquant : l'affichage du PDF ne dépend pas des métadonnées
      }
    });
  }

  private loadPdf(): void {
    this.loading = true;
    this.loadError = false;

    this.collaborateurService.getCvBlob(this.data.collaborateurId).subscribe({
      next: (blob) => {
        const typedBlob = blob.type === 'application/pdf'
          ? blob
          : blob.slice(0, blob.size, 'application/pdf');

        this.objectUrl = URL.createObjectURL(typedBlob);
        this.pdfSafeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(this.objectUrl);
        this.loading = false;
      },
      error: (err) => {
        this.loading = false;
        this.loadError = true;
        this.snackbarService.openSnackBar(
          this.extractErrorMessage(err, 'Erreur lors du chargement du CV'),
          'error-snack-bar'
        );
      }
    });
  }

  download(): void {
    window.open(this.collaborateurService.downloadCvUrl(this.data.collaborateurId), '_blank');
  }

  close(): void {
    this.dialogRef.close();
  }

  private extractErrorMessage(err: any, fallback: string): string {
    const body = err?.error;
    if (body?.message && typeof body.message === 'string') return body.message;
    if (typeof body === 'string') return body;
    return fallback;
  }
}
